'use strict';

angular.module('atex.dam').controller('DamRelatedJobsController', ['$scope', '$q','$stateParams', 'ContentService','$window', 'DamTaskService', 'DamNotificationService', '$translate',
  function($scope, $q, $stateParams, ContentService, $window, DamTaskService, DamNotificationService, $translate) {
    $scope.id = $stateParams.id;
    $scope.entries = [];
    $scope.selected  = [];

    $scope.clearSelection = function() {
      $scope.selected.length = 0;
    };

    $scope.back = function() {
      $window.history.back();
    };

    ContentService.getContent({id : $scope.id}).then(function(response) {
      response._data=response.data;
      $scope.name = response.data.aspects.contentData.data.name;
      $scope.entries.push(response);

      var tasks = atex.onecms.ObjectUtils.getByPath($scope.entries[0]._data.aspects, 'contentData/data/tasks') || [];

      DamTaskService.tasks(tasks).then(function(results) {
        $scope.entries[0]._data.aspects.contentData.data.objects=results;
        $scope.entries[0].show = true;
      });
    }).then(null, function(error) {
      DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: $translate.getTranslationTable().__GENERIC_ERROR_MSG__}), true);
    });
}]);

